// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const numberInputClasses = {
  control: "qui-number-input__control",
  errorIndicator: "qui-number-input__error-indicator",
  input: "qui-number-input__input",
  inputGroup: "qui-number-input__input-group",
  stepTrigger: "qui-number-input__step-trigger",
  unitSelect: "qui-number-input__unit-select",
} as const
